<template>
  <div
    class="A-bottom-single-button"
    :class="customClass"
  >
    <div
      v-if="balloonTrigger"
      class="balloon flex flex-justify-center flex-align-center"
    >
      {{ balloonText }}
    </div>
    <el-button
      ref="buttonRef"
      class="A-single-button flex flex-justify-center flex-align-center"
      :disabled="!disabled[0] || !disabled[1]"
      :loading="!!loadingTime && clickLoading"
      @click="clickButton"
    >
      <p :id="idName ? idName : ''">
        {{ text }}
      </p>
    </el-button>
  </div>
</template>

<script setup lang="ts">
import type { ElButton } from 'element-plus'

const props = withDefaults(
  defineProps<{
    balloonText?: string
    balloonTrigger?: boolean
    text?: string
    loadingTime?: number
    disabled?: boolean[]
    customClass?: string
    idName?: string
  }>(),
  {
    balloonText: '',
    balloonTrigger: false,
    text: '',
    loadingTime: 0,
    disabled: () => [true, true],
    customClass: '',
    idName: ''
  }
)

const emits = defineEmits(['click-button'])

const clickLoading = ref(false)

const clickButton = () => {
  clickLoading.value = true
  emits('click-button')
  setTimeout(() => {
    clickLoading.value = false
  }, props.loadingTime)
}

const buttonRef = ref<InstanceType<typeof ElButton> | null>(null)

onMounted(() => {
  if (buttonRef.value && props.idName) {
    // @ts-ignore
    buttonRef.value.ref.id = `${props.idName}`
  }
})
</script>
